import PropTypes from 'prop-types';

/** This is simply to provide clear definition of what a column should consist of **/
const BrColumns = (props) => {
  return props;
};
BrColumns.PropTypes = {
  key: PropTypes.string.isRequired, // this should match the keys used in data row object
  displayName: PropTypes.string, // will be rendered as Header Text, name will be used if this is not provided
  titleAlign: PropTypes.oneOf(['left', 'center', 'right']),
  contentAlign: PropTypes.oneOf(['left', 'center', 'right']),
  infoElement: PropTypes.element, // will render along with displayName
  column: PropTypes.func,
  columnConfig: PropTypes.object,
  headerClassName: PropTypes.string,
  headerTemplate: PropTypes.func,
  headerConfig: PropTypes.object,

  width: PropTypes.number, // if not specified, will take on column's default, or 200 if column doens't have default
  flexGrow: PropTypes.number, // default=0
  flexShrink: PropTypes.number, // default=0
  // this is required if any of filter/sort capability is used
  type: PropTypes.oneOf(['string', 'number', 'checkboxEnum']),
  isSearchable: PropTypes.bool,
  addToUnifiedFilter: PropTypes.bool,
  unifiedFilterConfig: PropTypes.shape({
    valueTitleArrayMap: PropTypes.arrayOf(
      // use this to show another display text for a value, example for value = 0, title = "Enabled"
      PropTypes.shape({ value: PropTypes.any, title: PropTypes.string }),
    ),
  }),
  isSortable: PropTypes.bool,
  isAdvanceSort: PropTypes.bool,
  isFilterable: PropTypes.bool,
  filterValues: PropTypes.array,

  exportEnabled: PropTypes.bool,
};
export default BrColumns;
